import packageCard from "./package_card";

export default {
  components: {
    packageCard,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    monthlyPrice: {
      type: String,
      default: "10",
    },
    annualPrice: {
      type: String,
      default: "10",
    },
    optionList: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  data() {
    return {
      tab: "yearly",
      tabList: [
        { id: "yearly", title: "Yearly (Save 20%)" },
        { id: "monthly", title: "Monthly" },
      ],
    };
  },
  methods: {
    setTab(tab) {
      this.tab = tab;
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/settings/components/subscription_plan.ctrl.js